function PisRunsController(stateService, toasterService, userService, $state) {
  const ctrl = this;

  ctrl.$onInit = () => {
    let selectedWorkspace = stateService.getSelectedWorkspace();
    ctrl.workspaceId = selectedWorkspace.id;
    ctrl.isLocked = selectedWorkspace.deployable;
    if (!ctrl.workspaceId) $state.go('pis.workspaces');
    stateService.getRunsAndRoutes(ctrl.workspaceId).then(data => ctrl.runs = data.runs);
    ctrl.editMode = false;
    ctrl.modalOptions = {
      name: 'run',
      fields: [
        { name: 'Name', key: 'name', type: 'row' },
        { name: 'Description', key: 'description', type: 'row' },
        { name: 'Stations', key: 'stations', type: 'list', listKey: 'name' }
      ],
      deleteCheck: false,
    };
    ctrl.hasCommit = userService.hasCommitPIS();
    ctrl.hasEdit = userService.hasEditPIS();
  };

  ctrl.onToggleEdit = event => {
    ctrl.editMode = event.editMode;
    ctrl.selection = event.item;
  };

  ctrl.onDelete = event => {
    stateService.deleteRun(ctrl.workspaceId, event.itemId).then(
      response => {
        stateService.getRunsAndRoutes(ctrl.workspaceId).then(data => ctrl.runs = data.runs);
        toasterService.success('toaster.pis-event', 'toaster.pis-delete-run-successful');
      },
      function(e) {
        toasterService.error('toaster.pis-event', 'toaster.pis-delete-run-failure');
        console.log(e);
      }
    );
  };

  ctrl.onFormSubmit = event => {
    ctrl.editMode = event.mode;
    stateService.getRunsAndRoutes(ctrl.workspaceId).then(data => ctrl.runs = data.runs);
    ctrl.selection = null;
  };


  ctrl.setEditMode = () => {
    ctrl.editMode = true;
  };

  ctrl.goBackToList = () => {
    ctrl.editMode = false;
    ctrl.selection = null;
  };
  
}

angular
  .module('pis-tool.module')
  .controller('PisRunsController', PisRunsController);
